module.exports = __webpack_public_path__ + "static/media/SF-12-A.47b7608d.mp3";